const SocialMediaIcons: React.FC<{ colour: string }> = ({ colour }) => {
  return (
    <div className="flex gap-x-6 items-center">
      <a href="https://facebook.com/JiweIO">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21.885"
          height="21.753"
          viewBox="0 0 21.885 21.753"
        >
          <path
            id="Icon_awesome-facebook"
            data-name="Icon awesome-facebook"
            d="M22.448,11.505A10.943,10.943,0,1,0,9.8,22.315V14.668H7.015V11.505H9.8V9.094c0-2.742,1.633-4.257,4.133-4.257a16.84,16.84,0,0,1,2.45.214V7.742H15a1.582,1.582,0,0,0-1.783,1.709v2.054H16.25l-.485,3.163H13.215v7.647A10.946,10.946,0,0,0,22.448,11.505Z"
            transform="translate(-0.563 -0.563)"
            fill={colour || "#b0b4b9"}
          />
        </svg>
      </a>
      <a href="https://twitter.com/jiwe_io">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.822"
          height="16.943"
          viewBox="0 0 20.822 16.943"
        >
          <path
            id="Icon_ionic-logo-twitter"
            data-name="Icon ionic-logo-twitter"
            d="M22.235,6.508a8.636,8.636,0,0,1-2.453.675,4.287,4.287,0,0,0,1.88-2.365,8.488,8.488,0,0,1-2.714,1.037,4.271,4.271,0,0,0-7.391,2.921,4.182,4.182,0,0,0,.11.975,12.106,12.106,0,0,1-8.807-4.47,4.28,4.28,0,0,0,1.328,5.71,4.172,4.172,0,0,1-1.941-.534v.053A4.276,4.276,0,0,0,5.676,14.7a4.3,4.3,0,0,1-1.125.15,4.03,4.03,0,0,1-.8-.079,4.279,4.279,0,0,0,3.993,2.969,8.565,8.565,0,0,1-5.308,1.831,8.659,8.659,0,0,1-1.019-.062,11.94,11.94,0,0,0,6.539,1.933A12.082,12.082,0,0,0,20.117,9.274c0-.185,0-.371-.013-.552A8.7,8.7,0,0,0,22.235,6.508Z"
            transform="translate(-1.413 -4.5)"
            fill={colour || "#b0b4b9"}
          />
        </svg>
      </a>
      <a href="https://www.youtube.com/@JiweEsports/playlists">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19.358"
          height="19.358"
          viewBox="0 0 19.358 19.358"
        >
          <path
            id="Icon_metro-youtube"
            data-name="Icon metro-youtube"
            d="M8.113,1.928,6.805,4.522,5.5,1.928H3.829L6.187,6.036,6.2,6.028V9.187H7.41V6.028l.014.008L9.782,1.928Zm3.532,2.42a.613.613,0,0,1,.6.6v2.42a.6.6,0,1,1-1.21,0V4.953A.613.613,0,0,1,11.645,4.348Zm0-1.21A1.82,1.82,0,0,0,9.83,4.953v2.42a1.815,1.815,0,1,0,3.63,0V4.953a1.82,1.82,0,0,0-1.815-1.815Zm5.445,0V7.9c-.528.44-1.21.706-1.21-.863v-3.9H14.67V7.284h0c.019,1,.23,2.8,2.418,1.337v.566H18.3V3.138h-1.21Zm1.815,12.1a.606.606,0,0,0-.6.6v.6h1.21v-.6a.606.606,0,0,0-.6-.6Zm-5.445.6v3.176c.41.41,1.21.454,1.21-.151V16.031C14.67,15.426,14.065,15.237,13.46,15.842Zm8.37-2.92A2.516,2.516,0,0,0,19.356,10.5c-1.319-.066-4.338-.1-6.989-.1s-5.885.033-7.2.1a2.516,2.516,0,0,0-2.474,2.426c-.079,1.42-.119,1.935-.119,2.645s.04,1.775.119,3.2a2.516,2.516,0,0,0,2.474,2.426c1.319.066,4.552.1,7.2.1s5.67-.033,6.989-.1a2.516,2.516,0,0,0,2.474-2.426q.1-1.775.1-3.2c0-.947-.033-1.462-.1-2.645ZM6.2,20.076H4.99V14.027H3.781v-1.21H7.41v1.21H6.2Zm4.84,0H9.83V19.51c-2.3,1.291-2.4.042-2.418-.959h0V15.237H8.62V18.57c0,.731.682.66,1.21.22V15.237h1.21Zm4.84-1.227c0,1.265-1.3,1.633-2.42.65v.577H12.25V12.817h1.21v1.966c1.21-1.21,2.42-.756,2.42.454Zm4.84-2.4v.6H18.3v1.21a.6.6,0,1,0,1.21,0v-.6h1.21v.6a1.815,1.815,0,1,1-3.63,0v-2.42a1.815,1.815,0,1,1,3.63,0Z"
            transform="translate(-2.571 -1.928)"
            fill={colour || "#b0b4b9"}
          />
        </svg>
      </a>
      <a href="https://tiktok" className="hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19.627"
          height="22.591"
          viewBox="0 0 19.627 22.591"
        >
          <path
            id="Icon_simple-tiktok"
            data-name="Icon simple-tiktok"
            d="M12.677.019C13.91,0,15.133.009,16.357,0A5.863,5.863,0,0,0,18,3.925,6.638,6.638,0,0,0,22,5.61V9.4a10.075,10.075,0,0,1-3.953-.913,11.63,11.63,0,0,1-1.525-.875c-.009,2.749.009,5.5-.019,8.236a7.19,7.19,0,0,1-1.271,3.709,7.013,7.013,0,0,1-5.563,3.022,6.864,6.864,0,0,1-3.84-.97,7.1,7.1,0,0,1-3.436-5.375c-.019-.471-.028-.941-.009-1.4A7.086,7.086,0,0,1,10.6,8.547c.019,1.393-.038,2.786-.038,4.179a3.23,3.23,0,0,0-4.123,2A3.734,3.734,0,0,0,6.3,16.237a3.2,3.2,0,0,0,3.295,2.7,3.162,3.162,0,0,0,2.607-1.515,2.172,2.172,0,0,0,.386-1c.094-1.685.056-3.36.066-5.045.009-3.793-.009-7.577.019-11.361Z"
            transform="translate(-2.369)"
            fill={colour || "#b0b4b9"}
          />
        </svg>
      </a>
      <a href="https://instagram.com/jiwe_esports">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.826"
          height="20.826"
          viewBox="0 0 20.826 20.826"
        >
          <g
            id="Icon_feather-instagram"
            data-name="Icon feather-instagram"
            transform="translate(1 1)"
          >
            <path
              id="Path_42"
              data-name="Path 42"
              d="M7.706,3h9.413a4.706,4.706,0,0,1,4.706,4.706v9.413a4.706,4.706,0,0,1-4.706,4.706H7.706A4.706,4.706,0,0,1,3,17.119V7.706A4.706,4.706,0,0,1,7.706,3Z"
              transform="translate(-3 -3)"
              fill="none"
              stroke={colour || "#b0b4b9"}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_43"
              data-name="Path 43"
              d="M19.554,15.148a3.765,3.765,0,1,1-3.172-3.172,3.765,3.765,0,0,1,3.172,3.172Z"
              transform="translate(-6.376 -6.328)"
              fill="none"
              stroke={colour || "#b0b4b9"}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_44"
              data-name="Path 44"
              d="M26.25,9.75h0"
              transform="translate(-11.66 -5.514)"
              fill="none"
              stroke={colour || "#b0b4b9"}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      </a>
      <a href="https://twitch.tv/" className="hidden">
        <svg
          id="Icon_ionic-logo-twitch"
          data-name="Icon ionic-logo-twitch"
          xmlns="http://www.w3.org/2000/svg"
          width="18.355"
          height="19.767"
          viewBox="0 0 18.355 19.767"
        >
          <path
            id="Path_45"
            data-name="Path 45"
            d="M4.787,2.25,3.375,5.78V19.193H7.611v2.824h2.824l2.824-2.824h3.53l4.942-4.942v-12Zm14.825,11.3-2.824,2.824H12.553L9.729,19.193V16.369H6.2v-12H19.612Z"
            transform="translate(-3.375 -2.25)"
            fill={colour || "#b0b4b9"}
          />
          <path
            id="Path_46"
            data-name="Path 46"
            d="M22.5,10.055h2.118v5.692H22.5Z"
            transform="translate(-10.499 -5.157)"
            fill={colour || "#b0b4b9"}
          />
          <path
            id="Path_47"
            data-name="Path 47"
            d="M14.625,10.055h2.118v5.692H14.625Z"
            transform="translate(-7.565 -5.157)"
            fill={colour || "#b0b4b9"}
          />
        </svg>
      </a>
    </div>
  );
};

export default SocialMediaIcons;
